<template>
    <div class="seek-range">
        <h5 class="text-center m-0">{{ selectRange.tolerance }} Risk</h5>
        <!-- <input
            id="customRange2"
            :value="riskType"
            type="range"
            class="form-range"
            min="1"
            max="5"
            @change="changeRange"
        /> -->
        <b-form-input
            id="range-1"
            v-model="mutableValue"
            type="range"
            min="0"
            :max="mutableRange.length - 1"
            @change="changeRange"
        ></b-form-input>
    </div>
</template>
<script>
export default {
    props: {
        value: { type: Number },
        range: { type: Array },
    },
    data() {
        return {
            mutableValue: 0,
            mutableRange: '',
            selectRange: {},
        }
    },
    watch: {
        value: function (newVal, oldVal) {
            // watch it
            // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
            this.mutableValue = newVal
            this.changeRange(newVal)
        },
    },
    mounted() {
        this.mutableValue = this.value
        this.mutableRange = this.range
        this.selectRange = this.mutableRange[this.mutableValue]
        // console.log('Values: ' + JSON.stringify(this.mutableValue))
        // console.log('Ranges: ' + JSON.stringify(this.mutableRange))

        // this.changeRange()
    },
    methods: {
        changeRange(event) {
            this.selectRange = ''
            this.selectRange = this.mutableRange[event]
            this.$emit('input', event)
            // console.log(':Selected Ranges ' + this.selectRange)

            // if (
            //     this.mutableRange &&
            //     this.mutableRange.length &&
            //     this.mutableRange.length > 0
            // ) {
            //     this.selectRange = this.mutableRange.filter((element) => {
            //         if (element._id == this.mutableValue) {
            //             this.$emit('input', event)
            //             debugger
            //             return element.tolerance
            //         }
            //     })
            // }
        },
    },
}
</script>
